<template>
  <div :style=bgColorStyles ref="container">
    <div class="ff__container" :style=containerStyles>
      <split-wrapper
        :imageWidthClass="schema.settings.imageWidth"
        :textAlignmentClass="schema.settings.textAlignment"
        :reversedClass="schema.settings.layout"
        :marginTop="schema.settings.marginTop"
        :marginBottom="schema.settings.marginBottom"
      >
        <template slot="image">

          <a
            class="ff__image ff__image--mobile"
            :href="schema.settings.ctaUrl"
            :style="[imageShiftStyles]"
            :aria-label="schema.settings.subheader || schema.settings.preheader"
          >
          </a>
          <a
            class="ff__image ff__image--desktop hidden-sm"
            :href="schema.settings.ctaUrl"
            :style="[imageShiftStyles]"
            :aria-label="schema.settings.subheader || schema.settings.preheader"
          >
          </a>
          <div
            v-if="schema.settings.secondaryImage"
            class="secondary-image-container"
            :style="secondaryImageShiftStyles"
          >

            <image-ratio
              :src=schema.settings.secondaryImage
              alt="Secondary Image"
              ratio="4:5"
              inverse
            ></image-ratio>
          </div>
        </template>
        <template slot="content">
          <div :style=swAndSecondaryImageStyles class="ff__main-wrap">
            <p
              class="preheader ff__preheader"
              :class="schema.settings.preheaderColor"
              v-if="schema.settings.preheader"
            >{{ schema.settings.preheader }}</p>
            <h2
              class="ff__header h4"
              :class="[schema.settings.headerColor]"
              v-if="schema.settings.header"
            >{{ schema.settings.header }}</h2>
            <p
              class="subheader ff__subheader"
              :class="schema.settings.subheaderColor"
              v-if="schema.settings.subheader"
            >{{ schema.settings.subheader }}</p>
            <div
              class="ff__body body-md client-generated fifty-story"
              :class="{
                [schema.settings.bodyColor]: true,
                'ff-body-margin-bottom--none': !(
                  schema.settings.ctaText
                )
              }"
              v-html="schema.settings.body"
              v-if="schema.settings.body"
            ></div>
            <div class="ff__cta-container">
              
              <component
                :is="
                  /link/.test(schema.settings.ctaStyle) ? 'v-link' : 'link-button'
                "
                tag="a"
                :class="schema.settings.ctaStyle"
                :href="schema.settings.ctaUrl"
                v-if="schema.settings.ctaText"
                :label="schema.settings.ctaText"
              >{{ schema.settings.ctaText }}</component>
              <component
                :is="
                  /link/.test(schema.settings.ctaStyle2) ? 'v-link' : 'link-button'
                "
                tag="a"
                :class="schema.settings.ctaStyle2"
                :href="schema.settings.ctaUrl2"
                v-if="schema.settings.ctaText2"
                :label="schema.settings.ctaText2"
              >{{ schema.settings.ctaText2 }}</component>
            </div>
          </div>
        </template>
      </split-wrapper>
    </div>
  </div>
</template>

<script>
import VButton from '../buttons/VButton.vue';
import VLink from '../buttons/VLink.vue';
import LinkButton from '../buttons/LinkButton.vue';
import SplitWrapper from '../basic/SplitWrapper.vue';
import ImageRatio from '@/scripts/components/basic/ImageRatio.vue'
import throttle from '@/scripts/helpers/optimizedEventThrottle.js';

export default {
  name: 'FiftyFifty',
  props: {
    schema: Object,
  },
  computed: {
    containerStyles() {
      if (
        this.schema.settings.secondaryImage
        && this.schema.settings.layout === 'sw--reverse'
        && this.$mq !== 'mobile'
      ) {
        return {
          'max-width': this.schema.settings.maxWidth,
          'margin-right': '8.3333%'
        }
      } else if (
        this.schema.settings.secondaryImage
        && this.schema.settings.layout !== 'sw--reverse'
        && this.$mq !== 'mobile'
      ) {
        return {
          'max-width': this.schema.settings.maxWidth,
          'margin-left': '8.3333%'
        }
      } else {
        return {
          'max-width': this.schema.settings.maxWidth,
        }
      }
    },
    swAndSecondaryImageStyles() {
      if (
        this.schema.settings.secondaryImage
        && this.schema.settings.layout !== 'sw--reverse'
        && this.$mq !== 'mobile'
      ) {
        return {
          'margin-left': '80px'
        }
      }
    },
    bgColorStyles() {
      return {
        background: this.schema.settings.backgroundColor
      }
    },
    imageShiftStyles() {
      let scrollPosition = this.offsetTop - (this.scrollTop + this.windowHeight);
      let scrollProgression = Math.round(scrollPosition / this.containerHeight * 100);
      let translateDefault = this.$mq === 'mobile' ? 50 : 200;
      let translateY = translateDefault;

      if (scrollProgression * -1 > 0 ) {
        translateY = translateDefault - (translateDefault * (scrollProgression * -1 / 100));
      }

      return {
        transform: `translateY(${translateY}px)`,
        backgroundImage: `url(${this.$mq === 'mobile' ? this.schema.settings.imageMobile || this.schema.settings.imageDesktop : this.schema.settings.imageDesktop})`
      }
    },
    secondaryImageShiftStyles() {
      let scrollPosition = this.offsetTop - (this.scrollTop + this.windowHeight);
      let scrollProgression = Math.round(scrollPosition / this.containerHeight * 100);
      let translateY = 200;

      if (scrollProgression * -1 > 0 ) {
        translateY = 200 - (400 * (scrollProgression * -1 / 100));
      }

      return {
        transform: `translateY(${translateY}px)`,
      }
    }
  },
  components: {
    VButton,
    VLink,
    SplitWrapper,
    ImageRatio,
    LinkButton
  },
  data() {
    return {
      scrollTop: 0,
      windowHeight: 0,
      offsetTop: 0,
      containerHeight: 0,
      containerObserver: null,
    }
  },
  mounted() {
    window.bvaccel = window.bvaccel || {}
    if (!window.bvaccel.optimizedEvents) {
      window.bvaccel.optimizedEvents = true;
      throttle('scroll', 'optimizedScroll');
      throttle('resize', 'optimizedResize');
    }
    this.scrollTop = window.pageYOffset;
    this.windowHeight = window.innerHeight;
    this.offsetTop = this.$refs.container.offsetTop;
    this.containerHeight = this.$refs.container.offsetHeight;

    window.addEventListener('optimizedScroll', () => {
      this.scrollTop = window.pageYOffset;
    });

    window.addEventListener('optimizedResize', () => {
      this.windowHeight = window.innerHeight;
      this.offsetTop = this.$refs.container.offsetTop;
    });

    this.containerObserver = new ResizeObserver(entries => {
      this.offsetTop = this.$refs.container.offsetTop;
    });

    this.containerObserver.observe(this.$refs.container);
  }
};
</script>

<style lang="scss" scoped>


  .ff--expert {
    .ff__cta-container {
      display: none;
    }

    .ff__preheader {
      font-size: 14px;
      
      @include mobile-only {

        font-size: 14px;
        font-family: $font-family-primary;
        letter-spacing: 4.5px;
        line-height: 20px;
      }
    }

    .ff__main-wrap {
      max-width: 380px;
    }

    h2.ff__header.h4.color-black {

      color: $color-black-700;
      font-family: $font-family-primary;
      font-size: 55px;
      line-height: 60px;
      
      @include mobile-only {
        font-size: 40px;
        line-height: 42px;
      }
    }

    .ff__body p {

      font-size: 15px;
      letter-spacing: 0;
      line-height: 25px;
      font-family: $font-family-primary;

      @include mobile-only {
        font-size: 15px;
        letter-spacing: 0;
        line-height: 25px;
        font-family: $font-family-primary;
      }
    }
  }


  .ff--aboutus {
    .ff__main-wrap {
      max-width: 400px;
    }

    .ff__container {
      @include mobile-only {
        .sw.sw--50 {
          padding-right: 0;
        }

        .sw__image {
          padding-right: 0;
          margin-right: 0;
        }
      }
    }

    

    .ff__image {
      background-size: contain;

      @include mobile_only {
        background-size: cover;
      }
    }

    .sw__main {
      margin-top: 50px;
      
      .sw__main-wrap {
        @include mobile_only {
          margin-top: 50px;
        }
      }

      &__image {
        flex: 1 1 50%;
        min-height: 100%;
      }

      .ff__cta-container {
        @include mobile-only {
          margin-bottom: 25px;
        }
      }
    }

    h2.ff__header.h4.color-black {
      color: $color-green-slate-50;
      font-family: $font-family-primary;
      font-size: 4.125rem;
      line-height: 4.5625rem;
      text-transform: uppercase;
      font-weight: 500;
      
      @include mobile-only {
        font-size: 40px;
        line-height: 42px;
      }
    }
   
   
  }

  .ff {
    &__container {
      margin: 0 auto;

      @include mobile-only {
        .sw__main.text-center {
          .ff__main-wrap {
            margin: 0 auto;
          }
          
          .ff__cta-container {
            align-items: center;
          }
        }
      }
      
      .sw__image {
        position: relative;
        padding-right: 70px;
        height: auto;
      }
    }
  
    &__main-wrap {
      margin-left: auto;
      margin-right: auto;
      max-width: 350px;
      
      @include mobile-only {
        width: 92%;
        padding-top: 42px;
      }
    }

    &__main-wrap > * {
      margin-bottom: 8px;
    }

    &__main-wrap > *:last-child {
      margin-bottom: 0;
      margin-top: 23px;
    }

    &__preheader {
      margin-bottom: 36px;
      
      @include mobile-only {
        margin-bottom: 17px;
      }
    }

    &__header {
      @include tablet-up {
        margin-bottom: 16px;
      }
    }

    &__body {
      margin-bottom: 32px;
    }

    &__body-margin-bottom--none {
      margin-bottom: 0;
    }

    .sw &__image--desktop {
      display: none;
      position: relative;
    }

    .sw &__image--mobile {
      position: relative;
      height: 373px;
      margin-left: auto;
      margin-right: auto;
    }

    .button {
      margin: 0;
    }

    &__cta-container {
      @include mobile-only {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .button {
        display: block;
        margin-bottom: 16px;

        @include tablet-up {
          display: inline-block;
          margin: 0;

          &:not(:last-child) {
            margin-right: 16px;
          }
        }
      }
    }

    @include tablet-up {
      .sw &__image--mobile {
        display: none;
      }

      .sw &__image--desktop {
        display: block;
        max-width: 582px;
        height: 727px;
        margin: 0 0 0 auto;
      }

    }
  }

  .secondary-image-container {
    position: absolute;
    top: 39%;
    right: 0;
    width: 199px;
    height: 341px;
    min-height: 0;

    @include mobile-only {
      width: 120px;
      height: 207px;
      left: 70%;
      right: auto;
    }
  }

.ff--special {
   /deep/ div.sw__image {
     margin-right: 0;
     margin-left: 25px;
  } 
      

}


 
</style>
